import { useFetcher } from "./use-fetcher";

/**
 * Changelog documents describing a ruleset release must be named
 * `YYYY-MM-DD-ruleset-v<major>-<minor>-<patch>.md` (e.g.
 * `2026-09-22-ruleset-v2-0-0.md`). The date prefix keeps the changelog listing
 * sorted chronologically, the suffix lets us find the doc for a version.
 */
export function rulesetChangelogSlug(version: string) {
  return `ruleset-v${version.split(".").join("-")}`;
}

/**
 * Returns the app href of the changelog doc for the given ruleset version, or
 * null if there is no such doc (or the changelog index hasn't loaded yet).
 */
export function useRulesetChangelogHref(version: string) {
  const { data } = useFetcher<{ id: string }[]>("/docs/changelog/index.json");
  const slug = rulesetChangelogSlug(version);
  const page = data?.find((p) => p.id === slug || p.id.endsWith(`-${slug}`));

  return page ? `~/changelog/${page.id}` : null;
}
